// extracted by mini-css-extract-plugin
export default {"assetList":"AssetList_assetList__NN4aV","body":"AssetList_body__y5QNo"};